/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import styled, { css } from 'styled-components';

import { useTranslation } from 'react-i18next';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const Footer = styled.div(
  ({ theme }) => css`
    display: flex;
    p {
      margin-left: 16px;
    }

    ${({ theme }) => theme.newBreakpoint('sm')} {
      margin-top: 60px;
      p {
        font-size: 10px;
      }
      img {
        display: none;
      }
    }
  `
);

const Disclaimer = () => {
  const { t } = useTranslation();
  return (
    <Footer>
      <img
        width={81}
        src={`${publicPath}/banco_falabella.svg`}
        alt="Logo de la empresa"
        id="logo-empresa"
      />
      <p>
        {`${t('helpScreen.disclaimer.text')} `}
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => window.open(t('helpScreen.disclaimer.link'), '_blank', 'noopener')}
        >
          {t('helpScreen.disclaimer.textLink')}
        </span>
      </p>
    </Footer>
  );
};

export default Disclaimer;
